import { useCallback } from "react";
import { createKdsItemsForOrder } from "@/lib/kds-routing";

interface OrderItemForRouting {
  id: string;
  order_id: string;
  product_id: string | null;
  product_name: string;
  quantity: number;
  notes: string | null;
  combo_id: string | null;
  combo_selections: any;
}

export function useKdsRouting(restaurantId: string | null) {
  const createKdsItems = useCallback(async (
    orderId: string,
    orderItems: OrderItemForRouting[]
  ) => {
    if (!restaurantId || orderItems.length === 0) return;
    await createKdsItemsForOrder(restaurantId, orderId, orderItems);
  }, [restaurantId]);

  return { createKdsItemsForOrder: createKdsItems };
}
